export default __webpack_public_path__ + "static/media/cancel.bb185823.svg";